/**
 * Copyright © 2026 Adnuntius AS.
 */
import {Injectable} from '@angular/core';
import {map, Observable} from 'rxjs';

import {ApiConfig} from '../../config/api-config';
import {OBJECT_STATE} from '../../common/constants/resource-constants';
import {transformJsonProperty} from '../../../components/util/adn-http-resource-transforms';
import {AdnApiClientService} from '../../common/controller/adn-api-client.service';

const transform = transformJsonProperty('data');

@Injectable({providedIn: 'root'})
export class QueryStatsTemplateApiService {
  private readonly uri = this.apiConfig.getVersionedUri('querystatstemplates');

  constructor(private readonly client: AdnApiClientService, private readonly apiConfig: ApiConfig) {
  }

  list(pageSize = 1001): Observable<any> {
    return this.client.request<any>({
      method: 'GET',
      url: this.uri,
      params: {
        includeHidden: false,
        includeActive: true,
        includeInactive: false,
        orderBy: 'name',
        pageSize
      }
    }).pipe(map((page) => ({
      ...page,
      results: (page.results || []).map((model: any) => transform.transformResponse(model))
    })));
  }

  save(model: any): Observable<any> {
    return this.client.request<any>({
      method: 'POST',
      url: this.itemUri(model.id),
      body: transform.transformRequest(model)
    }).pipe(map((saved) => transform.transformResponse(saved)));
  }

  archive(id: string): Observable<any> {
    return this.client.request({
      method: 'POST',
      url: this.itemUri(id),
      body: {id, objectState: OBJECT_STATE.inactive}
    });
  }

  private itemUri(id: string): string {
    return this.uri + '/' + encodeURIComponent(id);
  }
}
